import React from "react";
import { Row } from "react-bootstrap";
import { NoEventsFound } from "./EventsPanelParts";
import FutureEventCard from "./FutureEventCard";

export function FutureEventsPanel({ events }) {
  return (
    <section className="px-2 mb-5">
      <Row className="mx-n2">
        {events.map((event) => (
          <FutureEventCard key={event.eventId} {...event} />
        ))}
        {!events?.length && <NoEventsFound />}
      </Row>
    </section>
  );
}
